import checklistsApiService from '@/services/api/Checklists'

const emptyFilters = {
  yacht_ids: null,
  yacht_id: null,
  check_in_from: null,
  check_in_to: null,
  check_out_from: null,
  check_out_to: null,
  type: null
}

export default class Base {
  static api = checklistsApiService
  static emptyFilters = emptyFilters
}
